import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/empty.png'


const _hoisted_1 = { class: "empty-data" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  width: "200",
  src: _imports_0,
  alt: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, _toDisplayString(_ctx.message), 1)
  ]))
}